import { render } from "./Univ-Dept-Details.vue?vue&type=template&id=112eccbf&scoped=true"
import script from "./Univ-Dept-Details.vue?vue&type=script&lang=js"
export * from "./Univ-Dept-Details.vue?vue&type=script&lang=js"

import "./Univ-Dept-Details.vue?vue&type=style&index=0&id=112eccbf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-112eccbf"

export default script